let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8z4fw")).then(() => parcelRequire('fKfs1'));